import type { ApiRequest } from '../models/ApiRequest';
import type { ApiResponse } from '../models/ApiResponse';
import { apiInstance } from "./apiInstance";


export function checkEligibility(file: File, apiRequest: ApiRequest): Promise<ApiResponse> {
  const apiRequestJson = JSON.stringify(apiRequest);
  const apiRequestBlob = new Blob([apiRequestJson], { type: 'application/json' });
  const formData = new FormData();
  formData.append('file', file);
  formData.append('request', apiRequestBlob);

  return apiInstance.post('/lookup-by-file', formData, {
    headers: {
      'Content-Type': 'multipart/form-data',
    },
  }).then((response) => response.data);
}

